import { ProductInterface } from '@pylot-data/fwrdschema'
import { Maybe } from '@pylot-data/fwrdschema'

type YotpoReviewData = {
    '@type'?: 'Review'
    author?: {
        '@type'?: 'Person'
        name?: string
    }
    datePublished?: Maybe<string>
    name?: Maybe<string>
    reviewBody?: Maybe<string>
    reviewRating?: {
        '@type'?: 'Rating'
        ratingValue?: Maybe<number>
        bestRating?: number
        worstRating?: number
    }
}
export const getYotpoReviews = (
    product: ProductInterface
): Record<string, unknown> => {
    const reviewsToSchema: Maybe<Array<YotpoReviewData>> = []
    const getDatePublished = (date: string): string => {
        let formatedDate = ''
        if (date && date !== '' && date.length > 15)
            formatedDate = `${date
                .substring(5, 10)
                .replace('-', '/')}/${date.substring(0, 4)}`
        return formatedDate
    }
    if (product?.yotpo_reviews) {
        product?.yotpo_reviews.map((review) => {
            const reviewData: YotpoReviewData = {
                '@type': 'Review',
                author: {
                    '@type': 'Person',
                    name: review.user.display_name!
                },
                datePublished: getDatePublished(review.created_at!),
                name: review.title,
                reviewBody: review.content,
                reviewRating: {
                    '@type': 'Rating',
                    ratingValue: review.score,
                    bestRating: 5,
                    worstRating: 1
                }
            }
            reviewsToSchema.push(reviewData)
        })
    }

    return {
        review: reviewsToSchema
    }
}
